import React, {useState} from 'react'
import { useSelector } from 'react-redux'
import {Upload, Input, Form, Row, Typography, Avatar, Spin, Image, Alert} from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import * as FirestoreService from '../../firebase'

const {Title} = Typography
const PostForm = (props) => {
    const user = useSelector(state => state.user)
    const profile = useSelector(state => state.profile)

    const [imgUrl, setImgUrl] = useState();

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState();

    const onFinish = (values) => {

        setLoading(true);
        props.formReady(false);
        delete values.dragger
        if(imgUrl){
            values.imgUrl = imgUrl;
        }
        if(profile.avatarUrl){
            values.userAvatarUrl = profile.avatarUrl
        }else{
            values.userAvatarSymbols = profile.firstName.charAt(0) +  profile.lastName.charAt(0)
        }
        values.username = user.username
        FirestoreService.createPost(values);
        setLoading(false);
        props.formReady(true);
        props.onChange()
      }

    function beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            setError('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            setError('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
      }

    const handleChange = info => {
        if (info.file.status === 'uploading') {
            setLoading(true);
            props.formReady(false);
          return;
        }
        if (info.file.status === 'done') {
            setImgUrl(info.file.response[0].url)
            props.formReady(true);
            setLoading(false)
            setError()
        }
      };
    return (
        <>
        <Spin
            size="large"
            spinning={loading}
            delay={100}
        >
            <Form name="post-form" onFinish={onFinish} >
                <Row align="middle">
                    {profile.avatarUrl 
                        ? 
                        <Avatar size="large" src={profile.avatarUrl} />
                        : 
                        <Avatar size="large">
                            {profile.firstName.charAt(0) +  profile.lastName.charAt(0) }
                        </Avatar>
                    }
                    <Title level={5} style={{marginLeft:10}}>{user.username}</Title>
                </Row>
                <Form.Item name="content" 
                            rules={[
                            {
                                required: true,
                                message: "Enter content for a post",
                                type: "string",
                            },
                            {
                                max: 200,
                                message: "Maximum 200 Symbols",
                                type: "string",
                            }
                            ]}  
                >
                    <Input.TextArea  autoSize  style={{minHeight:80, fontSize:18, border:"none", resize:"none"}}
                    placeholder="What would you like to share...?"/>
                </Form.Item>
                
                <Form.Item name="dragger" valuePropName="files" noStyle>
                    <Upload.Dragger name="files" 
                        action={process.env.REACT_APP_BACKEND+"/upload"}
                        showUploadList={false}
                        beforeUpload={beforeUpload}
                        onChange={handleChange}
                    >
                    {
                        imgUrl 
                        ?
                            <Image preview={false} src={imgUrl}></Image>
                        :
                        <>
                            <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Click or drag image to this area to upload</p>
                        </>
                    }
                    </Upload.Dragger>
                </Form.Item>
                {
                    error &&
                        <Alert message={error} type="error" showIcon />
                }
            </Form>
        </Spin>
        </>
    )
}

export default PostForm
